module.exports = __webpack_public_path__ + "img/line.33ca4a0a.svg";